module.exports = __webpack_public_path__ + "static/media/gq.8199432b.svg";